module.exports = __webpack_public_path__ + "img/ranking.92baf23c.svg";